/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AgendaPageQuery = {
    readonly agenda: {
        readonly items: ReadonlyArray<{
            readonly programCommitee: ReadonlyArray<{
                readonly _id?: string;
                readonly _url?: string | null;
                readonly speakerName?: string;
                readonly speakerImage?: string;
                readonly speakerPreviewDescription?: string | null;
                readonly facebookLink?: string | null;
                readonly linkedinLink?: string | null;
                readonly twitterLink?: string | null;
                readonly location?: {
                    readonly country?: {
                        readonly _url?: string | null;
                    };
                };
            } | null> | null;
            readonly _children: {
                readonly items: ReadonlyArray<{
                    readonly _id?: string;
                    readonly _url?: string | null;
                    readonly title?: string;
                    readonly date?: unknown;
                    readonly endDayTime?: unknown;
                    readonly endDayText?: string | null;
                    readonly _children?: {
                        readonly items: ReadonlyArray<{
                            readonly title?: string;
                            readonly text?: string | null;
                            readonly startTime?: unknown;
                            readonly duration?: number;
                            readonly isBreakLine?: boolean;
                            readonly language?: string | null;
                            readonly background?: boolean;
                            readonly _id?: string;
                            readonly track?: ReadonlyArray<string | null> | null;
                            readonly type?: string;
                            readonly speakers?: ReadonlyArray<{
                                readonly speakerName?: string;
                                readonly speakerPreviewDescription?: string | null;
                                readonly _url?: string | null;
                                readonly speakerImage?: string;
                                readonly facebookLink?: string | null;
                                readonly linkedinLink?: string | null;
                                readonly twitterLink?: string | null;
                                readonly location?: {
                                    readonly country?: {
                                        readonly _url?: string | null;
                                    };
                                };
                            } | null> | null;
                            readonly _parent?: {
                                readonly _id?: string;
                                readonly title?: string;
                                readonly date?: unknown;
                                readonly endDayTime?: unknown;
                            } | null;
                        } | null> | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "AgendaPageQuery";
};
export type AgendaPageQuery$data = AgendaPageQuery;
export type AgendaPageQuery$key = {
    readonly " $data"?: AgendaPageQuery$data;
    readonly " $fragmentRefs": FragmentRefs<"AgendaPageQuery">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_url",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "speakerName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "speakerImage",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "speakerPreviewDescription",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facebookLink",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkedinLink",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitterLink",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "country",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v1/*: any*/)
              ],
              "type": "FilePublishedMedia",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "LocationPublishedContent",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDayTime",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startTime",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AgendaPageQuery",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AgendaPublishedContentConnection",
      "kind": "LinkedField",
      "name": "agenda",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AgendaPublishedContent",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "programCommitee",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v2/*: any*/),
                    (v3/*: any*/),
                    (v4/*: any*/),
                    (v5/*: any*/),
                    (v6/*: any*/),
                    (v7/*: any*/),
                    (v8/*: any*/)
                  ],
                  "type": "SpeakerPublishedContent",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PublishedContentConnection",
              "kind": "LinkedField",
              "name": "_children",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        (v9/*: any*/),
                        (v10/*: any*/),
                        (v11/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "endDayText",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PublishedContentConnection",
                          "kind": "LinkedField",
                          "name": "_children",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "items",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v9/*: any*/),
                                    (v12/*: any*/),
                                    (v13/*: any*/),
                                    (v14/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "isBreakLine",
                                      "storageKey": null
                                    },
                                    (v15/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "background",
                                      "storageKey": null
                                    }
                                  ],
                                  "type": "BreakLinePublishedContent",
                                  "abstractKey": null
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v0/*: any*/),
                                    (v14/*: any*/),
                                    (v15/*: any*/),
                                    (v13/*: any*/),
                                    (v12/*: any*/),
                                    (v9/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "track",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "type",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": null,
                                      "kind": "LinkedField",
                                      "name": "speakers",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "kind": "InlineFragment",
                                          "selections": [
                                            (v2/*: any*/),
                                            (v4/*: any*/),
                                            (v1/*: any*/),
                                            (v3/*: any*/),
                                            (v5/*: any*/),
                                            (v6/*: any*/),
                                            (v7/*: any*/),
                                            (v8/*: any*/)
                                          ],
                                          "type": "SpeakerPublishedContent",
                                          "abstractKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": null,
                                      "kind": "LinkedField",
                                      "name": "_parent",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "InlineFragment",
                                          "selections": [
                                            (v0/*: any*/),
                                            (v9/*: any*/),
                                            (v10/*: any*/),
                                            (v11/*: any*/)
                                          ],
                                          "type": "EventDayPublishedContent",
                                          "abstractKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "type": "SpeechPublishedContent",
                                  "abstractKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "type": "EventDayPublishedContent",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PublishedContentByTypeQuery",
  "abstractKey": null
};
})();
(node as any).hash = 'd6c92e9fa7b061a4f1f1b830dc981143';
export default node;
